import { TweenMax, Power2 } from "gsap";

import KansoDOM from "./_dom";

export default class Kanso {
    constructor() {
        this._init();
    }

    show(data, grade) {
        this.data = data;
        this.grade = grade;
        this.maxIndex = data._usrDatas.length;
        this.dom.setUser(data._usrDatas[this.nowIndex]);
        this.dom.setBook(data._bindData);

        TweenMax.set(this.$inner, { opacity: 0, y: 40 });
        TweenMax.to(this.$inner, 0.5, { opacity: 1, y: 0, ease: Power2.out });

        this.$self.classList.add("-active");
        this.$self.classList.add(`-${this.grade}`);

        // 顔アイコン部分
        this.$usrName.dataset.index = this.nowIndex;
    }

    hide() {
        this.$self.classList.remove("-active");
        this.$self.classList.remove(`-${this.grade}`);
        this.dom.reset();
        this.nowIndex = 0;
        this.maxIndex = 0;
        this.grade = "";
    }

    _init() {
        this.dom = new KansoDOM();
        this.nowIndex = 0;
        this.maxIndex = 0;
        this.grade = "";

        this.$self = document.querySelector(".kanso-sp");
        this.$inner = this.$self.querySelector(".kanso__inner");
        this.$btnPrev = this.$self.querySelector(".js-kanso-prev");
        this.$btnNext = this.$self.querySelector(".js-kanso-next");
        this.$btnClose = this.$self.querySelector(".js-kanso-close");
        this.$usrName = this.$self.querySelector(".js-kanso-username");
        this.$usrText = this.$self.querySelector(".js-kanso-usertext");

        this._ui();
    }

    _ui() {
        this.$btnPrev.addEventListener("click", () => {
            --this.nowIndex;
            if (this.nowIndex < 0) this.nowIndex = this.maxIndex - 1;
            this.dom.setUser(this.data._usrDatas[this.nowIndex]);

            // 顔アイコン部分
            this.$usrName.dataset.index = this.nowIndex;

            this._changeAnime();
        });

        this.$btnNext.addEventListener("click", () => {
            ++this.nowIndex;
            if (this.nowIndex >= this.maxIndex) this.nowIndex = 0;
            this.dom.setUser(this.data._usrDatas[this.nowIndex]);

            // 顔アイコン部分
            this.$usrName.dataset.index = this.nowIndex;

            this._changeAnime();
        });

        this.$btnClose.addEventListener("click", () => {
            this.hide();
        });

        const $cmain = document.querySelector(".c-main");
        if ($cmain.classList.contains("-open")) {
            this.$self.classList.add("-open");
        }

        const mediaQueryList = window.matchMedia('(min-width: 769px)');
        mediaQueryList.addEventListener("change", e=>{
            if(e.matches) this.hide();
        });
    }

    _changeAnime() {
        TweenMax.set([this.$usrName, this.$usrText], { opacity: 0, x: 40 });
        TweenMax.to(this.$usrName, 0.5, { opacity: 1, x: 0, ease: Power2.out });
        TweenMax.to(this.$usrText, 0.5, { delay: 0.15, opacity: 1, x: 0, ease: Power2.out });
    }
}
